import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { removeLoadingKey } from '../helpers/common'
import { getProductsRequest } from './productsSlice'

export const EDTLoadingKeys = {
    getEDTOptions: "GET_EDT_OPTIONS",
    addEDTOptions: "ADD_EDT_OPTION",
    updateEDTByProduct: "UPDATE_EDT_BY_PRODUCT"
}

const initialState = {
    loading: false,
    loadingKeys: [],
    error: null,
    options: []
}

export const updateEDTByProductRequest = createAsyncThunk(
    'edt/updateEDTByProductRequest',
    async ({
        productId,
        newEDT,
        search,
        page, 
        itemsPerPage,
        phasedStatuses,
        amazon,
        kit,
    }, { rejectWithValue, dispatch }) => {
      try {
        const { data } = await axios.post(`/api/v1/update-edt-by-product`, { productId, newEDT });
        await dispatch(getProductsRequest({
            search,
            page, 
            itemsPerPage,
            phasedStatuses,
            amazon,
            kit,
        }))
        return data;
      } catch (error) {
        if ('string' === typeof error.response.data) {
          return rejectWithValue({ error: error.response.data })
        } else {
          return rejectWithValue({ error: error.response.data.errors })
        }
      }
    }
);


export const getEDTOptionsRequest = createAsyncThunk(
    'edt/getEDTOptionsRequest',
    async ({}, { rejectWithValue }) => {
      try {
        const { data } = await axios.get(`/api/v1/get-edt-options`);
        return data;
      } catch (error) {
        if ('string' === typeof error.response.data) {
          return rejectWithValue({ error: error.response.data })
        } else {
          return rejectWithValue({ error: error.response.data.errors })
        }
      }
    }
)

export const addEDTOptionRequest = createAsyncThunk(
    'edt/addEDTOptionRequest',
    async ({
      value,
    }, { rejectWithValue, dispatch }) => {
      try {
        const { data } = await axios.post(`/api/v1/add-new-edt`, { value });
        await dispatch(getEDTOptionsRequest({}));
        return data;
      } catch (error) {
        if ('string' === typeof error.response.data) {
          return rejectWithValue({ error: error.response.data })
        } else {
          return rejectWithValue({ error: error.response.data.errors })
        }
      }
    }
);

export const edtSlice = createSlice({
    name: 'edt',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getEDTOptionsRequest.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, EDTLoadingKeys.getEDTOptions];
        })
        .addCase(getEDTOptionsRequest.fulfilled, (state, action) => {
            state.loading = false;
            state.options = action.payload?.options;
            state.error = null;
            state.loadingKeys = removeLoadingKey(EDTLoadingKeys.getEDTOptions, state.loadingKeys);
        })
        .addCase(getEDTOptionsRequest.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(EDTLoadingKeys.getEDTOptions, state.loadingKeys);
        })
        .addCase(addEDTOptionRequest.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, EDTLoadingKeys.addEDTOptions];
        })
        .addCase(addEDTOptionRequest.fulfilled, (state) => {
            state.loading = false;
            state.error = null;
            state.loadingKeys = removeLoadingKey(EDTLoadingKeys.addEDTOptions, state.loadingKeys);
        })
        .addCase(addEDTOptionRequest.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(EDTLoadingKeys.addEDTOptions, state.loadingKeys);
        })
        .addCase(updateEDTByProductRequest.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, EDTLoadingKeys.updateEDTByProduct];
        })
        .addCase(updateEDTByProductRequest.fulfilled, (state) => {
            state.loading = false;
            state.error = null;
            state.loadingKeys = removeLoadingKey(EDTLoadingKeys.updateEDTByProduct, state.loadingKeys);
        })
        .addCase(updateEDTByProductRequest.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(EDTLoadingKeys.updateEDTByProduct, state.loadingKeys);
        })
    }
})

export const {} = edtSlice.actions;

export default edtSlice.reducer
